import { SortDestinationColorSchema } from "@redotech/redo-fulfillment-wms-common/schema/sort-destination";
import { SortDispositionSchema } from "@redotech/redo-fulfillment-wms-common/schema/sort-disposition";
import {
  sortDestinationIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const SortDestinationSchema = z.object({
  id: sortDestinationIdFormat.schema,
  name: z.string(),
  disposition: SortDispositionSchema,
  color: SortDestinationColorSchema,
  destinationStorageLocationId: storageLocationIdFormat.schema.nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const listSortDestinations = {
  name: "listSortDestinations" as const,
  input: z.object({}),
  output: z.object({ sortDestinations: z.array(SortDestinationSchema) }),
};
